var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 780.77 924.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1 {\r\n                mask: url(#mask);\r\n            }\r\n\r\n            .cls-2,\r\n            .cls-27,\r\n            .cls-29,\r\n            .cls-31,\r\n            .cls-33 {\r\n                mix-blend-mode: multiply;\r\n            }\r\n\r\n            .cls-2 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_10);\r\n            }\r\n\r\n            .cls-3 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_78);\r\n            }\r\n\r\n            .cls-4 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_79);\r\n            }\r\n\r\n            .cls-5 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_32);\r\n            }\r\n\r\n            .cls-6 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_32-2);\r\n            }\r\n\r\n            .cls-36,\r\n            .cls-7,\r\n            .cls-81 {\r\n                fill: #fff;\r\n            }\r\n\r\n            .cls-8 {\r\n                fill: url(#linear-gradient);\r\n            }\r\n\r\n            .cls-9 {\r\n                fill: url(#linear-gradient-2);\r\n            }\r\n\r\n            .cls-10 {\r\n                fill: #df6981;\r\n            }\r\n\r\n            .cls-11 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_32-3);\r\n            }\r\n\r\n            .cls-12 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_32-4);\r\n            }\r\n\r\n            .cls-13 {\r\n                fill: #4b6f9f;\r\n            }\r\n\r\n            .cls-14 {\r\n                isolation: isolate;\r\n            }\r\n\r\n            .cls-15 {\r\n                mask: url(#mask-2);\r\n            }\r\n\r\n            .cls-16 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3);\r\n            }\r\n\r\n            .cls-17 {\r\n                fill: url(#linear-gradient-3);\r\n            }\r\n\r\n            .cls-18 {\r\n                fill: url(#linear-gradient-4);\r\n            }\r\n\r\n            .cls-19 {\r\n                clip-path: url(#clip-path);\r\n            }\r\n\r\n            .cls-20 {\r\n                fill: #2540be;\r\n            }\r\n\r\n            .cls-21 {\r\n                fill: url(#linear-gradient-5);\r\n            }\r\n\r\n            .cls-22 {\r\n                clip-path: url(#clip-path-2);\r\n            }\r\n\r\n            .cls-23 {\r\n                fill: url(#linear-gradient-6);\r\n            }\r\n\r\n            .cls-24 {\r\n                fill: url(#linear-gradient-7);\r\n            }\r\n\r\n            .cls-25 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_32-5);\r\n            }\r\n\r\n            .cls-26 {\r\n                clip-path: url(#clip-path-3);\r\n            }\r\n\r\n            .cls-27 {\r\n                fill: url(#linear-gradient-9);\r\n            }\r\n\r\n            .cls-28 {\r\n                fill: #191d7f;\r\n            }\r\n\r\n            .cls-29 {\r\n                fill: url(#linear-gradient-10);\r\n            }\r\n\r\n            .cls-30 {\r\n                clip-path: url(#clip-path-4);\r\n            }\r\n\r\n            .cls-31 {\r\n                fill: url(#linear-gradient-12);\r\n            }\r\n\r\n            .cls-32 {\r\n                clip-path: url(#clip-path-5);\r\n            }\r\n\r\n            .cls-33 {\r\n                fill: #e6edf9;\r\n            }\r\n\r\n            .cls-34 {\r\n                fill: #121650;\r\n            }\r\n\r\n            .cls-35 {\r\n                fill: url(#linear-gradient-13);\r\n            }\r\n\r\n            .cls-36 {\r\n                mix-blend-mode: soft-light;\r\n            }\r\n\r\n            .cls-37 {\r\n                fill: #5684f9;\r\n            }\r\n\r\n            .cls-38 {\r\n                fill: url(#linear-gradient-14);\r\n            }\r\n\r\n            .cls-39 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_32-6);\r\n            }\r\n\r\n            .cls-40 {\r\n                fill: url(#linear-gradient-15);\r\n            }\r\n\r\n            .cls-41 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_32-7);\r\n            }\r\n\r\n            .cls-42,\r\n            .cls-51,\r\n            .cls-81 {\r\n                opacity: 0.5;\r\n            }\r\n\r\n            .cls-43,\r\n            .cls-71 {\r\n                fill: #20267f;\r\n            }\r\n\r\n            .cls-43 {\r\n                opacity: 0;\r\n            }\r\n\r\n            .cls-44 {\r\n                fill: #232c87;\r\n                opacity: 0.06;\r\n            }\r\n\r\n            .cls-45 {\r\n                fill: #27328e;\r\n                opacity: 0.13;\r\n            }\r\n\r\n            .cls-46 {\r\n                fill: #2a3896;\r\n                opacity: 0.19;\r\n            }\r\n\r\n            .cls-47 {\r\n                fill: #2e3e9e;\r\n                opacity: 0.25;\r\n            }\r\n\r\n            .cls-48 {\r\n                fill: #3143a5;\r\n                opacity: 0.31;\r\n            }\r\n\r\n            .cls-49 {\r\n                fill: #3449ad;\r\n                opacity: 0.38;\r\n            }\r\n\r\n            .cls-50 {\r\n                fill: #384fb4;\r\n                opacity: 0.44;\r\n            }\r\n\r\n            .cls-51 {\r\n                fill: #3b55bc;\r\n            }\r\n\r\n            .cls-52 {\r\n                fill: #3e5bc4;\r\n                opacity: 0.56;\r\n            }\r\n\r\n            .cls-53 {\r\n                fill: #4261cb;\r\n                opacity: 0.63;\r\n            }\r\n\r\n            .cls-54 {\r\n                fill: #4567d3;\r\n                opacity: 0.69;\r\n            }\r\n\r\n            .cls-55 {\r\n                fill: #496ddb;\r\n                opacity: 0.75;\r\n            }\r\n\r\n            .cls-56 {\r\n                fill: #4c72e2;\r\n                opacity: 0.81;\r\n            }\r\n\r\n            .cls-57 {\r\n                fill: #4f78ea;\r\n                opacity: 0.88;\r\n            }\r\n\r\n            .cls-58 {\r\n                fill: #537ef1;\r\n                opacity: 0.94;\r\n            }\r\n\r\n            .cls-59 {\r\n                fill: #3b68fa;\r\n            }\r\n\r\n            .cls-60 {\r\n                fill: #83a8fa;\r\n            }\r\n\r\n            .cls-61 {\r\n                fill: #e8f0fd;\r\n            }\r\n\r\n            .cls-62 {\r\n                fill: #c7d9fd;\r\n            }\r\n\r\n            .cls-63 {\r\n                clip-path: url(#clip-path-6);\r\n            }\r\n\r\n            .cls-64 {\r\n                fill: url(#linear-gradient-16);\r\n            }\r\n\r\n            .cls-65 {\r\n                clip-path: url(#clip-path-7);\r\n            }\r\n\r\n            .cls-66 {\r\n                fill: url(#linear-gradient-17);\r\n            }\r\n\r\n            .cls-67 {\r\n                fill: url(#linear-gradient-18);\r\n            }\r\n\r\n            .cls-68 {\r\n                clip-path: url(#clip-path-8);\r\n            }\r\n\r\n            .cls-69 {\r\n                fill: url(#linear-gradient-19);\r\n            }\r\n\r\n            .cls-70 {\r\n                clip-path: url(#clip-path-9);\r\n            }\r\n\r\n            .cls-72 {\r\n                clip-path: url(#clip-path-10);\r\n            }\r\n\r\n            .cls-73 {\r\n                clip-path: url(#clip-path-11);\r\n            }\r\n\r\n            .cls-74 {\r\n                fill: url(#linear-gradient-20);\r\n            }\r\n\r\n            .cls-75 {\r\n                fill: url(#linear-gradient-21);\r\n            }\r\n\r\n            .cls-76 {\r\n                fill: url(#linear-gradient-22);\r\n            }\r\n\r\n            .cls-77 {\r\n                fill: url(#linear-gradient-23);\r\n            }\r\n\r\n            .cls-78 {\r\n                fill: url(#linear-gradient-24);\r\n            }\r\n\r\n            .cls-79 {\r\n                clip-path: url(#clip-path-12);\r\n            }\r\n\r\n            .cls-80 {\r\n                fill: url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45);\r\n            }\r\n\r\n            .cls-82 {\r\n                filter: url(#luminosity-noclip-2);\r\n            }\r\n\r\n            .cls-83 {\r\n                filter: url(#luminosity-noclip);\r\n            }\r\n        "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 8.09,
    y: -8604,
    width: 761.91,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 8.09,
    y: -8604,
    width: 761.91,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_10",
    x1: 259.45,
    y1: 136.57,
    x2: 626.66,
    y2: 820.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_78",
    x1: 229,
    y1: 679.61,
    x2: 211.02,
    y2: 634.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04B486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_79",
    x1: 95.18,
    y1: 564.89,
    x2: 141.18,
    y2: 569.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04B486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32",
    x1: 567.06,
    y1: 443.42,
    x2: 664.02,
    y2: 443.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20267f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#04B486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04B486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32-2",
    x1: 598.92,
    y1: 481.52,
    x2: 663.82,
    y2: 481.52,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 175.92,
    y1: 210.2,
    x2: 221.7,
    y2: 210.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1cfba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d388a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 190.49,
    y1: 191.26,
    x2: 247.83,
    y2: 191.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32-3",
    x1: 593.23,
    y1: 740.07,
    x2: 79.52,
    y2: 911.31,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32-4",
    x1: 630.41,
    y1: 851.63,
    x2: 116.77,
    y2: 1022.84,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 8.09,
    y: 7.63,
    width: 761.91,
    height: 812.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 18.86,
    y: 0,
    width: 761.91,
    height: 812.43,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M717.09,231.54C730,32.77,539-59.23,375.6,62.22c-88.79,66-64,127.5-256.17,240.17C-68.71,412.68-5.21,618.87,211,665.19c151.6,32.49,262.94,227,435.32,126.13C884.72,651.85,702.44,456.46,717.09,231.54Z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3",
    x1: 259.45,
    y1: 136.57,
    x2: 626.66,
    y2: 820.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5684f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04B486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 192.54,
    y1: 254.52,
    x2: 397.65,
    y2: 254.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 384.71,
    y1: 178.58,
    x2: 410.87,
    y2: 178.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234.19,586.12c3.82,8.33-9.86,18.31-33.1,53.45-17.68,26.73-3.33,35.7-29.81,78.71-9.19,14.93-23.08,21.62-13.89,34.94,14.92,21.61,21.33,38.62,25.86,42.17,11.52,9,19.53,5.36,13.46-10.1-4.85-12.36-9.53-41-1.94-54.69,13.8-25,72.27-113.72,90.44-136.11,8.88-10.95.31-30.34-13.48-59.3C251,491.69,218.54,436,215.64,429.92,194.37,385.18,168.58,443.17,234.19,586.12Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 183.25,
    y1: 691.84,
    x2: 222.36,
    y2: 691.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.34,391.68c-21.45,35.48-17.34,66.48.68,94,23.53,35.89,71.77,90.8,71.77,100s-2.29.46-39,21.11c-27.95,15.71-19.29,30.24-62.5,56.4-15,9.08-30.42,8.7-28.33,24.74,3.39,26,1.32,44.09,3.72,49.32,6.11,13.31,14.92,13.68,16.59-2.84,1.34-13.21,10.26-40.8,23.28-49.53,23.69-15.9,96.61-53.31,122.42-66.17,27-13.48,28.45-34.72,16.36-56.72-11.6-21.12-57.51-140.82-57.51-140.82L147,387.25Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 124.8,
    y1: 649.16,
    x2: 166.39,
    y2: 649.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 276.6,
    y1: 155.65,
    x2: 199.66,
    y2: 276.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#df6981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c314d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32-5",
    x1: 192.34,
    y1: 319.89,
    x2: 119.68,
    y2: 314.55,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.61,198.79c0-10.57-1.78-9.84-1.78-9.84-1-3,.41-8.18-5.12-9.69-10.85-3-9.12,23.82-3.82,23.42,6.81-.51-7.88,20.22-7.88,20.22-2.23,7.68,39.74,18.46,39.74,18.46-1.58-11,4.31-23.61,5.89-31.5C222.86,203.79,204.46,198,194.61,198.79Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 193.05,
    y1: 224.83,
    x2: 219.16,
    y2: 224.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 204.03,
    y1: 195.05,
    x2: 163.87,
    y2: 188.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M196.93,168.4c-4.66,23.54-10.11,32.09-3.09,43.83,10.32,17.25,14,17.66,22.94,19.23,8.7,1.54,22-20.52,24.26-25,3.67-7.2.79-7.86,2.65-15.58,1.2-5,2.54-5.13,3.94-15C251.36,149.68,202.64,139.54,196.93,168.4Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 192.54,
    y1: 223.12,
    x2: 282.94,
    y2: 223.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M192.54,187.71c4.87,3.67,11.48,2.12,16-4.78s11.9-27.31,26.31-17.47c2.68,1.83,9.44-6.13,5.87,11.6-2.22,11,.67,22.47,6.11,33.48s4.33,22.91-2.35,44.93,8.19,46.88,37.57,41.17c0,0,5.57-17.16,1.79-24.65-7.53-15-9.67-17.4-2.18-30.18s10.8-26.87.37-38-8.3-34.65-13.59-47.65-29.15-27.39-46.76-16.67c0,0-9.88-4.13-19.15,6.09C187.16,162.52,192.54,187.71,192.54,187.71Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 157.12,
    y1: 326.72,
    x2: 194.26,
    y2: 326.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 126.67,
    y1: 316.52,
    x2: 308.87,
    y2: 316.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32-6",
    x1: 195.11,
    y1: 282.15,
    x2: 122.45,
    y2: 276.81,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 298.54,
    y1: 350.3,
    x2: 339.01,
    y2: 350.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32-7",
    x1: 428.22,
    y1: 321.54,
    x2: 570.61,
    y2: 609.32,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_32"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M307.27,825.1c-27.16,20.5-48.64,14.69-60.69,9.75-20.23-8.3-33.38-9.82-23.3,10.11C231.41,861,255,866,270.79,875.25c18.34,10.67,22.41-12.25,43.57-22.73C337.7,840.95,307.27,825.1,307.27,825.1Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 285.7,
    y1: 846.36,
    x2: 309.61,
    y2: 870.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7d9fd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M475.8,870.88c3.14,33.86-14.53,29.7-24.8,32.06-21.31,4.89-24.12,21.12-1.86,23,17.95,1.55,34,10.89,50.11,2.3,18.73-10,1.38-25.49,3.6-49C505.3,853.39,475.8,870.88,475.8,870.88Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 462.18,
    y1: 902.58,
    x2: 524.63,
    y2: 878.67,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 675.87,
    y1: 539.31,
    x2: 538.76,
    y2: 486.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3b68fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b68fa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M660,535.9c6.51,9.07-47.81,12-46.23,1s-6.82-30.11-8.4-38c-1.06-5.28,36.38-37.47,42.61,4.42C649.39,512.69,653.35,526.6,660,535.9Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 582.81,
    y1: 520.16,
    x2: 640.8,
    y2: 525.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M581.59,420.11a33.57,33.57,0,0,1,31,1.57c4.67,2.67,10.76,1.89,15.23,0,10.7-4.57,38.81,8,36,30.15-6.14,9.48-5.71,8.81-17.91,15-7.27,3.67-43.64-2.32-47,3l-6.48-6.52C575.88,467.87,550.86,434.16,581.59,420.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610.86,449.84c19.52,9.44,46.7,11.78,53,2-3.9,24.56-9.07,39.67-14.21,58.08l-24.53,3.81-26.16-43.92C602.28,463.91,603.37,446.21,610.86,449.84Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M616.39,480.47c2,4.75,3.81,12.74-.16,17.89,6.18,8.76,16.64,13.94,15.87,14.25-11.16,4.46-23.41,8.59-27.55,8.69-8.84.2-13.43-26.88-14-31.91-.93-8,2.66-9.08,3.61-17C594.68,468,591,459.6,591,459.6c6.49-3.05,7.6-2.25,14.62,15.93C607.35,479.92,610.4,465.95,616.39,480.47Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 586.16,
    y1: 481.34,
    x2: 644.15,
    y2: 486.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 591.73,
    y1: 496.92,
    x2: 603.22,
    y2: 490.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 493.04,
    y1: 846.48,
    x2: 533.02,
    y2: 780.52,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 492.51,
    y1: 752.78,
    x2: 507.17,
    y2: 828.04,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 429.36,
    y1: 634.95,
    x2: 479.24,
    y2: 634.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12",
    transform: "translate(10.77 -7.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M687.91,521.3c-9.78-7.69-21.49.3-28.94-9.31-7.31,8.63-57.21,21.39-59.29,18.86,0,0-5.87,19.12-15.35,26.52-6.53,5.1-13.76,9.21-17.36,13.75-.14-.13-16.62,36.07-32.45,55.62-18.29,22.57-24.25,32.44-29.77,29.05s-23.1-11.37-25.5-12.83S463.55,663,472,670.3s34.62,28.1,46.2,26.81c8.77-1,44.21-36.41,63.94-60.41,8.2,29.38-7.67,67.76-6.08,82,3.69,32.9,109,25.31,122.51-18.65C710.62,653.81,714.14,541.91,687.91,521.3Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45",
    x1: 712.76,
    y1: 641.62,
    x2: 531.26,
    y2: 607.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8f0fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#dee9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c4d6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#99b8fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83a8fa"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M384.86,193.75s-40,50.58-56.76,68.87l-18.4,20.06s-35.64-14.41-57.91-28-54.1-35.19-54.1-35.19c-11.86,26.83-2.93,41.6,23.47,59.38C237.66,290,267.57,300,288.9,307.17c12.8,4.3,20.64,10.55,25.91,7.13,33.86-22,50.8-63.92,82.83-113.72A22.64,22.64,0,0,0,384.86,193.75Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M410.87,157.16c-.27-3.21-3.52.76-8,7.08a126.62,126.62,0,0,1-10.21,12.81c-1.63,1.62-.54-.54-2-3.79s-3.57-4.78-4.81-4.33-.84,2.53,0,5.6c1.48,5.41-.25,8.21-.52,11.46s1.18,4.88-.45,7.77,10.3,9.3,12.79,6.82,8.07-8.81,9.43-11.79,1.17-8-.54-11.46-2.89-4.15-2.26-6.41S411.14,160.36,410.87,157.16Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234.19,586.12c3.82,8.33-9.86,18.31-33.1,53.45-17.68,26.73-3.33,35.7-29.81,78.71-9.19,14.93-23.08,21.62-13.89,34.94,14.92,21.61,21.33,38.62,25.86,42.17,11.52,9,19.53,5.36,13.46-10.1-4.85-12.36-9.53-41-1.94-54.69,13.8-25,72.27-113.72,90.44-136.11,8.88-10.95.31-30.34-13.48-59.3C251,491.69,218.54,436,215.64,429.92,194.37,385.18,168.58,443.17,234.19,586.12Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M200.57,791.57c-1.75,3.78-5.24,5.53-11.79,3.2s-6.73-11.21-18.34-30.54c-8-13.37-11.21-22.54-11.06-36.21l-19.65,10.91-7.86,39.92,25,35.71,69.87,10.18S202.32,787.79,200.57,791.57Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M190,669.87s-4.91,15.38-6.66,24c-1.46,7.13,18.08,24.71,22.35,18.81,7.3-10.1,16.69-26.41,16.69-26.41S193,683.26,190,669.87Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.34,391.68c-21.45,35.48-17.34,66.48.68,94,23.53,35.89,71.77,90.8,71.77,100s-2.29.46-39,21.11c-27.95,15.71-19.29,30.24-62.5,56.4-15,9.08-30.42,8.7-28.33,24.74,3.39,26,1.32,44.09,3.72,49.32,6.11,13.31,14.92,13.68,16.59-2.84,1.34-13.21,10.26-40.8,23.28-49.53,23.69-15.9,96.61-53.31,122.42-66.17,27-13.48,28.45-34.72,16.36-56.72-11.6-21.12-57.51-140.82-57.51-140.82L147,387.25Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M92.13,743c-10-1.46-10.77-11.05-10.48-26s-1.6-35.92,6-57.45l-63.68,4.14L-10.77,769,97.3,835.13S102.18,744.45,92.13,743Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M143.64,625.37s-11.6,13.18-17.57,20.35c-4.66,5.59,4.49,30.2,11,26.94,11.21-5.62,29.33-15.89,29.33-15.89C151.8,654.15,143.64,625.37,143.64,625.37Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M190.63,207.9c-10.79,17,7.76,29.58-12.4-2.46-20.67-32.85,14.42-83,43.47-66,0,0,9.36-8.81,29.34,2.35s12.05,50.07,22.93,59.47,9.7,32.45,1.76,41-5,16.74,3.53,27.31,5.9,38.77-13.67,43.17c-23.83,5.36-32.48-19.38-34.24-35.83s-20.28-37-20.28-37Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M161.58,208.94c18.43,9.76,54.17,32.42,54.17,32.42l7.48-8.66c15.48,8.66,16.44,16,19.73,35,11.76,67.66-5.11,51-18,112.55-3.21,15.26-12.14,28.19-12.14,44.31-13.82,5.55-94.16,5.5-87.59-20.7a310.44,310.44,0,0,1,19-34c11.79-18.33-3.85-48.86-10.84-73.3S118.12,263.2,150.79,233Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.61,198.79c0-10.57-1.78-9.84-1.78-9.84-1-3,.41-8.18-5.12-9.69-10.85-3-9.12,23.82-3.82,23.42,6.81-.51-7.88,20.22-7.88,20.22-2.23,7.68,39.74,18.46,39.74,18.46-1.58-11,4.31-23.61,5.89-31.5C222.86,203.79,204.46,198,194.61,198.79Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M217.52,242.29l1.64-13.43-26.1-21.5C194.57,233.05,206.54,240.25,217.52,242.29Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M216.87,227c-.21.86-2.5,4-1.12,14.39a12.35,12.35,0,0,0,7.09-7.19C225.17,228.42,217.07,226.12,216.87,227Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M184.7,186.68c-1.42,3.05-2.11,14.49,4.67,13,8.39-1.89,1.4-9.82,1.4-9.82C187.16,183,186.11,183.63,184.7,186.68Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M196.93,168.4c-4.66,23.54-10.11,32.09-3.09,43.83,10.32,17.25,14,17.66,22.94,19.23,8.7,1.54,22-20.52,24.26-25,3.67-7.2.79-7.86,2.65-15.58,1.2-5,2.54-5.13,3.94-15C251.36,149.68,202.64,139.54,196.93,168.4Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M263.89,176.07l-16.05-43.32-55.29,6.67v48.29c13.53,6.67,19.31-6.44,28.3-15.61s14.67.45,13.93,3.76c-5.76,25.75,7.3,36.29-20.4,55.16l2.41.44s-1.73,9.24-.73,14.54c5.62,7.33,14.13,20,15.3,30.91,1.76,16.45,10.41,41.19,34.24,35.83,9.76-2.2,15.31-10.32,17.35-19.22L273.78,263Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M192.54,187.71c4.87,3.67,11.48,2.12,16-4.78s11.9-27.31,26.31-17.47c2.68,1.83,9.44-6.13,5.87,11.6-2.22,11,.67,22.47,6.11,33.48s4.33,22.91-2.35,44.93,8.19,46.88,37.57,41.17c0,0,5.57-17.16,1.79-24.65-7.53-15-9.67-17.4-2.18-30.18s10.8-26.87.37-38-8.3-34.65-13.59-47.65-29.15-27.39-46.76-16.67c0,0-9.88-4.13-19.15,6.09C187.16,162.52,192.54,187.71,192.54,187.71Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M250.06,182.76c2.18-14.83-1.31-24.29-9.46-23s-3.56-.15-14-1.31-16.41,21.77-29.23,34l49,24.09s10,4.85,5.24,20.27C265.2,220.72,247.78,198.28,250.06,182.76Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M178.59,222.32c1.15-3.23,2.7-5.5,4.82-11.44-7.86-2.91-20.86-4.13-21.83-1.94-2.77,6.27,7.85,14.61,22.18,21.41C183.76,230.36,177.27,226,178.59,222.32Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M157.12,282.09l3.71,36.34,11.78,51.77,21.13,1.14.51-19C181.71,333.79,168.53,291.47,157.12,282.09Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M215.64,429.92c-1-2-1.92-3.8-2.88-5.39h0c0-13.47,6.23-24.71,10.15-36.94,9.51-21.72,24-65.74,24-77.81C231,336,228,352.4,216.24,366.72c-17.37,21.09-53.82,48.92-39.89,65.27s14.81,52,37.62,95c13.16,24.79,30.62,50.38,31.54,54.65,2.5,11.68-1.78,26.84-32.12,42.47s-78.88,42.86-98.15,56.05-17.13,15.69-18.5,41.74h0c3.72-13.67,11.13-30.56,20.8-37.05,5.84-3.92,14.66-9.14,25-15,10.8-5.67,23.83-13.06,23.83-13.06h0c27.85-15,58.62-30.67,73.58-38.12,27-13.48,28.45-34.72,16.36-56.72-7.62-13.88-30.05-70.3-44.54-107.38,11.88,21.25,32,57.41,46.39,87.68,13.79,29,22.36,48.36,13.48,59.3-12.21,15.05-36.39,58.9-55.13,93.62,23.1-36.14,55.9-84.87,68.7-100.65,8.88-10.95.31-30.34-13.48-59.3C251,491.69,218.54,436,215.64,429.92Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M335.23,323.12l-13.8,3.66a7.53,7.53,0,0,0-4.95,5.58L307.36,368c-.54,2.1.8,3.95,2.53,3.51l13.72-3.47a7.51,7.51,0,0,0,5-5.59l9.17-35.86C338.32,324.51,337,322.66,335.23,323.12Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M217.77,361.23l-26.52,2.35s-16.13-34.7-23.2-59.73-15.68-62.48-15.68-62.48C126.1,253.12,122.76,270,130,301c4.53,19.34,19.46,46.89,30.08,66.58,6.37,11.82,7.88,21.72,13.94,22.76,38.9,6.7,78.85-12.76,134.84-27.81a23,23,0,0,0-4.69-13.67S241.94,359.09,217.77,361.23Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M163.29,263.74c.29-.85-8.46-24.87-8.46-24.87-25,8.11-30,18.14-30,35.44,0,19.61,9.32,42.39,9.32,42.39s12.8,6.92,39.85-4.81C174,311.89,163,264.59,163.29,263.74Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M337.36,342.47c1.43-4-.88-4.79-2.28-4.11s-1.2,4.65-4.89,7.15-17.7,2.29-15.61-2.94,1.76-8.66-2.18-5.09-4.85,7.17-13.12,12.12c0,0-3.56,10.67,4.94,13s24,2.57,27.14,1,2.94-7.31,5.33-11,2.61-7.87,2.12-9.14S337.36,342.47,337.36,342.47Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M551.73,51.35,355.44,123.09a43.83,43.83,0,0,0-28.8,41.16V679.47a20.08,20.08,0,0,0,27,18.84l196.29-71.74a43.83,43.83,0,0,0,28.8-41.16V70.19A20.08,20.08,0,0,0,551.73,51.35Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M554.41,52.89,358.11,124.64a43.83,43.83,0,0,0-28.8,41.16V681a20.08,20.08,0,0,0,27,18.84l196.29-71.74a43.83,43.83,0,0,0,28.8-41.16V71.73A20.08,20.08,0,0,0,554.41,52.89Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M459.46,182.53C425.31,195,397.62,237,397.62,276.37s27.69,61.28,61.84,48.86,61.84-54.43,61.84-93.84S493.61,170.11,459.46,182.53Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M459.46,184.24c-33.33,12.12-60.36,53.13-60.36,91.59s27,59.81,60.36,47.69,60.36-53.13,60.36-91.59S492.79,172.12,459.46,184.24Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M459.46,186c-32.51,11.82-58.87,51.82-58.87,89.34s26.36,58.34,58.87,46.52,58.87-51.82,58.87-89.34S492,174.13,459.46,186Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M459.46,187.66c-31.7,11.53-57.39,50.52-57.39,87.09s25.69,56.87,57.39,45.35,57.39-50.52,57.39-87.09S491.15,176.14,459.46,187.66Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M459.46,189.37c-30.88,11.23-55.91,49.21-55.91,84.84s25,55.4,55.91,44.18,55.91-49.21,55.91-84.84S490.34,178.14,459.46,189.37Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M459.46,191.08C429.4,202,405,239,405,273.68s24.37,53.94,54.43,43,54.43-47.91,54.43-82.59S489.52,180.15,459.46,191.08Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M459.46,192.79c-29.24,10.63-52.94,46.6-52.94,80.34s23.7,52.47,52.94,41.83,52.94-46.6,52.94-80.34S488.7,182.16,459.46,192.79Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M459.46,194.51C431,204.84,408,239.8,408,272.6s23,51,51.46,40.66,51.46-45.3,51.46-78.09S487.88,184.17,459.46,194.51Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M459.46,196.22c-27.6,10-50,44-50,75.84s22.38,49.53,50,39.49,50-44,50-75.84S487.06,186.18,459.46,196.22Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M459.46,197.93c-26.78,9.74-48.5,42.69-48.5,73.59s21.71,48.06,48.5,38.32S508,267.15,508,236.24,486.24,188.19,459.46,197.93Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M459.46,199.64c-26,9.44-47,41.38-47,71.34s21,46.59,47,37.15,47-41.38,47-71.34S485.42,190.19,459.46,199.64Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M459.46,201.35c-25.15,9.15-45.53,40.08-45.53,69.09s20.38,45.12,45.53,36S505,266.34,505,237.32,484.6,192.2,459.46,201.35Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M459.46,203.06c-24.33,8.85-44,38.77-44,66.84s19.72,43.65,44,34.8,44-38.77,44-66.84S483.79,194.21,459.46,203.06Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M459.46,204.77c-23.51,8.55-42.57,37.47-42.57,64.59S436,311.54,459.46,303,502,265.53,502,238.4,483,196.22,459.46,204.77Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M459.46,206.48c-22.69,8.25-41.08,36.16-41.08,62.34s18.39,40.71,41.08,32.46,41.08-36.16,41.08-62.34S482.15,198.23,459.46,206.48Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M459.46,208.19c-21.87,8-39.6,34.86-39.6,60.09s17.73,39.24,39.6,31.29,39.6-34.86,39.6-60.09S481.33,200.24,459.46,208.19Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M459.46,209.9c-21.05,7.66-38.12,33.55-38.12,57.84s17.07,37.78,38.12,30.12,38.12-33.55,38.12-57.84S480.51,202.24,459.46,209.9Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M416.61,327.27l-46.48,16.9c-13.19,4.8-23.89,19.37-23.89,32.56v69.88c0,13.18,10.69,20,23.89,15.18l46.48-16.91c13.19-4.8,23.89-19.37,23.89-32.56V342.46C440.5,329.27,429.8,322.48,416.61,327.27Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M416,328.93l-45.17,16.43c-13,4.73-23.54,19.09-23.54,32.08v67.32c0,13,10.54,19.69,23.54,15L416,443.29c13-4.73,23.54-19.09,23.54-32.08V343.89C439.5,330.9,429,324.2,416,328.93Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M415.3,330.58l-43.87,16c-12.81,4.66-23.19,18.81-23.19,31.61v64.77c0,12.8,10.38,19.4,23.19,14.74l43.87-16c12.81-4.66,23.19-18.81,23.19-31.61V345.32C438.5,332.52,428.11,325.92,415.3,330.58Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M414.65,332.24l-42.56,15.48c-12.62,4.59-22.85,18.53-22.85,31.14v62.21c0,12.61,10.23,19.11,22.85,14.52l42.56-15.48c12.62-4.59,22.85-18.53,22.85-31.14V346.76C437.5,334.15,427.27,327.65,414.65,332.24Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M414,333.89l-41.25,15c-12.43,4.52-22.5,18.25-22.5,30.67v59.65c0,12.42,10.07,18.82,22.5,14.3l41.25-15c12.43-4.52,22.5-18.25,22.5-30.67V348.19C436.5,335.77,426.42,329.37,414,333.89Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M413.34,335.54,373.4,350.07c-12.24,4.45-22.16,18-22.16,30.2v57.1c0,12.23,9.92,18.53,22.16,14.08l39.94-14.53c12.24-4.45,22.16-18,22.16-30.2v-57.1C435.5,337.4,425.58,331.09,413.34,335.54Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M412.68,337.2l-38.63,14.05c-12,4.38-21.81,17.69-21.81,29.73v54.54c0,12,9.76,18.24,21.81,13.86l38.63-14.05c12-4.38,21.81-17.69,21.81-29.73V351.06C434.5,339,424.73,332.82,412.68,337.2Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M412,338.85,374.7,352.43c-11.85,4.31-21.46,17.41-21.46,29.25v52c0,11.85,9.61,18,21.46,13.64L412,433.73c11.85-4.31,21.46-17.41,21.46-29.25v-52C433.5,340.65,423.89,334.54,412,338.85Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M411.38,340.51l-36,13.1c-11.66,4.24-21.12,17.13-21.12,28.78v49.43c0,11.65,9.46,17.66,21.12,13.42l36-13.1C423,427.9,432.5,415,432.5,403.36V353.93C432.5,342.27,423,336.26,411.38,340.51Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M410.72,342.16,376,354.78c-11.47,4.17-20.77,16.85-20.77,28.31V430c0,11.46,9.3,17.37,20.77,13.2l34.71-12.62c11.47-4.17,20.77-16.85,20.77-28.31V355.36C431.5,343.9,422.19,338,410.72,342.16Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M410.07,343.81,376.67,356c-11.28,4.1-20.43,16.57-20.43,27.84v44.32c0,11.27,9.15,17.08,20.43,13L410.07,429c11.28-4.1,20.43-16.57,20.43-27.84V356.79C430.49,345.52,421.35,339.71,410.07,343.81Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M409.41,345.47l-32.09,11.67c-11.09,4-20.08,16.29-20.08,27.37v41.76c0,11.08,9,16.8,20.08,12.76l32.09-11.67c11.09-4,20.08-16.29,20.08-27.37V358.23C429.49,347.15,420.5,341.43,409.41,345.47Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M408.76,347.12,378,358.32c-10.9,4-19.73,16-19.73,26.9v39.21c0,10.89,8.84,16.51,19.73,12.54l30.79-11.2c10.9-4,19.73-16,19.73-26.9V359.66C428.49,348.77,419.66,343.16,408.76,347.12Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M408.11,348.77,378.63,359.5c-10.71,3.89-19.39,15.73-19.39,26.42v36.65c0,10.7,8.68,16.22,19.39,12.32l29.48-10.72c10.71-3.89,19.39-15.73,19.39-26.42V361.1C427.49,350.4,418.81,344.88,408.11,348.77Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M407.45,350.43l-28.17,10.24c-10.52,3.82-19,15.44-19,26v34.1c0,10.51,8.53,15.93,19,12.1l28.17-10.24c10.52-3.82,19-15.44,19-26v-34.1C426.49,352,418,346.6,407.45,350.43Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M406.8,352.08l-26.86,9.77c-10.33,3.76-18.7,15.16-18.7,25.48v31.54c0,10.32,8.37,15.64,18.7,11.88L406.8,421c10.33-3.76,18.7-15.16,18.7-25.48V364C425.49,353.65,417.12,348.33,406.8,352.08Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M406.14,353.74,380.59,363c-10.13,3.69-18.35,14.88-18.35,25v29c0,10.13,8.22,15.35,18.35,11.66l25.55-9.29c10.13-3.69,18.35-14.88,18.35-25v-29C424.49,355.27,416.28,350.05,406.14,353.74Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M531.23,450,352,512.79c-9.26,3.37-16.78,13.61-16.78,22.86v49.07c0,9.26,7.51,14,16.78,10.66l179.24-62.76C540.49,529.25,548,519,548,509.76V460.68C548,451.42,540.49,446.65,531.23,450Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M530.65,451.52,352.83,513.78c-9.11,3.31-16.5,13.38-16.5,22.48v47.22c0,9.1,7.39,13.8,16.5,10.48L530.65,531.7c9.11-3.31,16.5-13.38,16.5-22.48V462C547.15,452.9,539.76,448.2,530.65,451.52Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M530.08,453,353.67,514.77c-9,3.26-16.22,13.15-16.22,22.1v45.37c0,8.95,7.26,13.56,16.22,10.31l176.41-61.76c9-3.26,16.22-13.15,16.22-22.1V463.32C546.29,454.37,539,449.76,530.08,453Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M529.5,454.51l-175,61.26c-8.8,3.2-15.94,12.93-15.94,21.72V581c0,8.79,7.14,13.33,15.94,10.13l175-61.26c8.8-3.2,15.94-12.93,15.94-21.72V464.64C545.44,455.84,538.3,451.31,529.5,454.51Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M528.93,456,355.35,516.76c-8.65,3.14-15.66,12.7-15.66,21.34v41.66c0,8.64,7,13.1,15.66,10L528.93,529c8.65-3.14,15.66-12.7,15.66-21.34V466C544.58,457.31,537.57,452.86,528.93,456Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M528.35,457.5,356.19,517.75c-8.49,3.09-15.38,12.47-15.38,21v39.81c0,8.49,6.88,12.86,15.38,9.77L528.35,528c8.49-3.09,15.38-12.47,15.38-21V467.27C543.73,458.79,536.84,454.41,528.35,457.5Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M527.77,459,357,518.75c-8.34,3-15.1,12.25-15.1,20.58v38c0,8.33,6.76,12.63,15.1,9.6l170.74-59.75c8.34-3,15.1-12.25,15.1-20.58v-38C542.87,460.26,536.11,456,527.77,459Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M527.2,460.49,357.88,519.74c-8.18,3-14.82,12-14.82,20.2V576c0,8.18,6.63,12.39,14.82,9.42L527.2,526.21c8.18-3,14.82-12,14.82-20.2V469.91C542,461.73,535.38,457.51,527.2,460.49Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M526.62,462l-167.9,58.75c-8,2.92-14.54,11.79-14.54,19.81V574.8c0,8,6.51,12.16,14.54,9.24l167.9-58.75c8-2.92,14.54-11.79,14.54-19.81V471.23C541.16,463.2,534.65,459.07,526.62,462Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M526,463.48,359.56,521.73c-7.87,2.86-14.26,11.56-14.26,19.43v32.4c0,7.87,6.38,11.93,14.26,9.06L526,524.38c7.88-2.86,14.26-11.56,14.26-19.43v-32.4C540.3,464.68,533.92,460.62,526,463.48Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M525.47,465,360.4,522.72c-7.72,2.81-14,11.34-14,19.05v30.55c0,7.71,6.26,11.69,14,8.88l165.07-57.75c7.72-2.81,14-11.34,14-19.05V473.86C539.45,466.15,533.19,462.17,525.47,465Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M524.89,466.47,361.24,523.72c-7.57,2.75-13.7,11.11-13.7,18.67v28.69c0,7.56,6.13,11.46,13.7,8.71l163.65-57.24c7.57-2.75,13.7-11.11,13.7-18.67v-28.7C538.59,467.62,532.46,463.72,524.89,466.47Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M524.32,468,362.08,524.71c-7.41,2.7-13.42,10.88-13.42,18.29v26.84c0,7.41,6,11.22,13.42,8.53l162.24-56.74c7.41-2.7,13.42-10.88,13.42-18.29V476.5C537.74,469.09,531.73,465.27,524.32,468Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M523.74,469.46,362.92,525.7c-7.26,2.64-13.14,10.66-13.14,17.91v25c0,7.25,5.88,11,13.14,8.35l160.82-56.24c7.26-2.64,13.14-10.66,13.14-17.91v-25C536.88,470.56,531,466.83,523.74,469.46Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M523.17,471,363.76,526.7c-7.1,2.58-12.86,10.43-12.86,17.53v23.14c0,7.1,5.76,10.76,12.86,8.17l159.4-55.74c7.1-2.58,12.86-10.43,12.86-17.53V479.13C536,472,530.27,468.38,523.17,471Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M522.59,472.46l-158,55.24c-6.95,2.53-12.58,10.2-12.58,17.15v21.28c0,6.94,5.63,10.52,12.58,8l158-55.24c6.95-2.53,12.58-10.2,12.58-17.15V480.45C535.17,473.51,529.54,469.93,522.59,472.46Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M522,474,365.44,528.69c-6.79,2.47-12.3,10-12.3,16.77v19.43c0,6.79,5.51,10.29,12.3,7.82L522,518c6.79-2.47,12.3-10,12.3-16.77V481.77C534.32,475,528.81,471.48,522,474Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M472.15,203.55c-25.23,9.18-45.69,40.22-45.69,69.34s20.46,45.28,45.69,36.1,45.69-40.22,45.69-69.34S497.39,194.37,472.15,203.55Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M472.15,225.37c-8,2.9-14.45,13.1-14.45,22.77s6.47,16.43,14.45,13.53,14.45-14.37,14.45-24S480.14,222.46,472.15,225.37Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M472.15,267.71c-15.75,5.73-28.53,16.17-28.53,23.31s12.77,12.68,28.53,7,28.53-20.56,28.53-27.7S487.91,262,472.15,267.71Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M364.75,178.82l-13,4.74a1.44,1.44,0,0,0-.85,1.29c0,.54.38.84.85.67l13-4.74a1.44,1.44,0,0,0,.85-1.29C365.6,179,365.22,178.65,364.75,178.82Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M364.53,172.87l-13,4.74a1.44,1.44,0,0,0-.85,1.29c0,.54.38.84.85.67l13-4.74a1.44,1.44,0,0,0,.85-1.29C365.38,173,365,172.7,364.53,172.87Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M359.17,186.54l-7.47,2.72a1.44,1.44,0,0,0-.85,1.29c0,.54.38.84.85.67l7.47-2.72a1.44,1.44,0,0,0,.85-1.29C360,186.67,359.64,186.37,359.17,186.54Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M541,556.14,480.83,578c-7.7,2.8-13.94,11.31-13.94,19h0c0,7.69,6.24,11.66,13.94,8.86L541,584c7.7-2.8,13.94-11.31,13.94-19h0C555,557.3,548.75,553.33,541,556.14Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M491.22,588.85l1.24-.45v1.78a5.61,5.61,0,0,1-1,.51,1.32,1.32,0,0,1-1.44-.13,2.37,2.37,0,0,1-.5-1.74,3.91,3.91,0,0,1,.56-2.1,2.92,2.92,0,0,1,1.52-1.25,2.83,2.83,0,0,1,1.46-.14l.34-1.07a3.74,3.74,0,0,0-1.78.23,4.54,4.54,0,0,0-2.29,1.78,5.12,5.12,0,0,0-.83,2.91,3.06,3.06,0,0,0,.74,2.35,2,2,0,0,0,2.1.17,8.28,8.28,0,0,0,1.08-.48,8.49,8.49,0,0,0,1-.67v-3.47l-2.2.8Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M496.56,584.36a2.87,2.87,0,0,0-1.52,1.29,4.27,4.27,0,0,0-.55,2.21,2.16,2.16,0,0,0,.6,1.74,1.61,1.61,0,0,0,1.65.11,5,5,0,0,0,.82-.38,4.26,4.26,0,0,0,.71-.53v-.9a5.71,5.71,0,0,1-.74.56,4.06,4.06,0,0,1-.75.36.91.91,0,0,1-.95-.06,1.37,1.37,0,0,1-.36-1l3-1.1V586a1.93,1.93,0,0,0-.52-1.54A1.36,1.36,0,0,0,496.56,584.36Zm-1.07,2.54a2.38,2.38,0,0,1,.33-1.1,1.44,1.44,0,0,1,.74-.6.67.67,0,0,1,.72.07,1.19,1.19,0,0,1,.27.88Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M500.83,587.14a.63.63,0,0,1-.17-.53v-2.8l1.29-.47v-.84l-1.29.47v-1.16l-.59.22-.33,1.23-.66.65v.49l.62-.22V587q0,1.66,1.37,1.17a3.28,3.28,0,0,0,.52-.24,2.67,2.67,0,0,0,.41-.28v-.84a2.9,2.9,0,0,1-.7.38A.47.47,0,0,1,500.83,587.14Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M507.62,583a2.64,2.64,0,0,0-.82-.16,2.94,2.94,0,0,1-.87-.15.35.35,0,0,1-.2-.34q0-.5.76-.78a2.72,2.72,0,0,1,1.23-.1l.31-.95a3.32,3.32,0,0,0-2.79,1,1.81,1.81,0,0,0-.47,1.21,1,1,0,0,0,.28.81,1.87,1.87,0,0,0,1.06.31,3.82,3.82,0,0,1,.63.09.74.74,0,0,1,.32.16.4.4,0,0,1,.1.3q0,.62-.89.94a2.88,2.88,0,0,1-1.49.12v1a2.77,2.77,0,0,0,1.45-.21,3.14,3.14,0,0,0,1.38-.91,2.06,2.06,0,0,0,.48-1.35,1.27,1.27,0,0,0-.12-.61A.78.78,0,0,0,507.62,583Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M510.39,583.66a.63.63,0,0,1-.17-.53v-2.8l1.29-.47V579l-1.29.47v-1.16l-.59.22-.33,1.23-.66.65v.49l.62-.23v2.82q0,1.66,1.37,1.17a3.26,3.26,0,0,0,.52-.24,2.67,2.67,0,0,0,.41-.28v-.84a2.89,2.89,0,0,1-.7.38A.47.47,0,0,1,510.39,583.66Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M515.54,577.89a1.51,1.51,0,0,0-1.3,0,4.42,4.42,0,0,0-.83.42,4.93,4.93,0,0,0-.81.63l.31.68a7.64,7.64,0,0,1,.61-.5,2.68,2.68,0,0,1,.67-.36.62.62,0,0,1,.63,0,.87.87,0,0,1,.2.68v.28l-.78.31a4,4,0,0,0-1.59,1,2.08,2.08,0,0,0-.52,1.41,1.23,1.23,0,0,0,.38,1,1.07,1.07,0,0,0,1,0,2.63,2.63,0,0,0,.85-.48,3.32,3.32,0,0,0,.66-.89h0l.19.66.69-.25V579.1Q516,578.17,515.54,577.89Zm-.52,3a1.81,1.81,0,0,1-.32,1.06,1.72,1.72,0,0,1-.84.64.59.59,0,0,1-.54,0,.54.54,0,0,1-.18-.48,1.2,1.2,0,0,1,.31-.83,2.64,2.64,0,0,1,1-.62l.58-.24Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M518.84,576.53a3.29,3.29,0,0,0-.59,1l0,0-.13-.88-.75.27v5.23l1-.35v-2.73a2.3,2.3,0,0,1,.36-1.26,1.84,1.84,0,0,1,.94-.78,1.67,1.67,0,0,1,.43-.1l.09-1.07a2.2,2.2,0,0,0-.48.13A2,2,0,0,0,518.84,576.53Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M522.17,579.38a.63.63,0,0,1-.17-.53V576l1.29-.47v-.84l-1.29.47V574l-.59.22-.33,1.23-.66.65v.49l.62-.23v2.82q0,1.66,1.37,1.17a3.27,3.27,0,0,0,.52-.24,2.66,2.66,0,0,0,.41-.28V579a2.89,2.89,0,0,1-.7.38A.47.47,0,0,1,522.17,579.38Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M526,573.64a2.87,2.87,0,0,0-1.52,1.29,4.27,4.27,0,0,0-.55,2.21,2.16,2.16,0,0,0,.6,1.74,1.61,1.61,0,0,0,1.65.11,5,5,0,0,0,.82-.38,4.26,4.26,0,0,0,.71-.53v-.9a5.69,5.69,0,0,1-.74.56,4,4,0,0,1-.75.36.91.91,0,0,1-.95-.06,1.37,1.37,0,0,1-.36-1l3-1.1v-.6a1.93,1.93,0,0,0-.52-1.54A1.36,1.36,0,0,0,526,573.64ZM525,576.18a2.38,2.38,0,0,1,.33-1.1,1.44,1.44,0,0,1,.74-.6.67.67,0,0,1,.72.07,1.19,1.19,0,0,1,.27.88Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M532,571.36a7,7,0,0,0,.07.86l0,0a1.1,1.1,0,0,0-1.36-.27,2.45,2.45,0,0,0-1.33,1.2,4.53,4.53,0,0,0-.48,2.18,2.74,2.74,0,0,0,.48,1.82,1.11,1.11,0,0,0,1.32.23,2.4,2.4,0,0,0,1.36-1.27l0,0,.17.62.75-.27V569.1l-1,.35Zm0,3a2.85,2.85,0,0,1-.28,1.35,1.55,1.55,0,0,1-.86.7.63.63,0,0,1-.8-.17,2.13,2.13,0,0,1-.27-1.23,3.38,3.38,0,0,1,.27-1.45,1.4,1.4,0,0,1,.78-.76q.59-.22.87.1a2.09,2.09,0,0,1,.28,1.3Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M433.23,595.28,373,617.18c-7.7,2.8-13.94,11.31-13.94,19h0c0,7.69,6.24,11.66,13.94,8.86l60.21-21.9c7.7-2.8,13.94-11.31,13.94-19h0C447.17,596.45,440.93,592.48,433.23,595.28Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M400.2,621.35a2.9,2.9,0,0,0-1-.24,3.64,3.64,0,0,1-.81-.15.64.64,0,0,1-.32-.24.79.79,0,0,1-.1-.42,1.17,1.17,0,0,1,.25-.72,1.52,1.52,0,0,1,.72-.5,3.06,3.06,0,0,1,1.43-.13l.31-1a3.46,3.46,0,0,0-1.71.19,3.09,3.09,0,0,0-1.43,1,2.48,2.48,0,0,0-.53,1.56,1.52,1.52,0,0,0,.34,1.06,1.76,1.76,0,0,0,1.16.45,2.5,2.5,0,0,1,1,.26.64.64,0,0,1,.25.56,1.25,1.25,0,0,1-.28.79,1.86,1.86,0,0,1-.86.57,3.34,3.34,0,0,1-.86.18,3.29,3.29,0,0,1-.87,0v1.07a3.21,3.21,0,0,0,1.66-.24,3.48,3.48,0,0,0,1.59-1.1,2.61,2.61,0,0,0,.58-1.66,1.73,1.73,0,0,0-.14-.76A1,1,0,0,0,400.2,621.35Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M404.19,617.89a2.31,2.31,0,0,0-.82.51,2.42,2.42,0,0,0-.55.78l-.06,0q0-.53,0-1v-1.87l-1,.35v7.36l1-.35v-2.59a3.2,3.2,0,0,1,.28-1.51,1.59,1.59,0,0,1,.89-.74q.46-.17.67.05a1.21,1.21,0,0,1,.21.83V623l1-.35V619.2Q405.84,617.29,404.19,617.89Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M410.26,616.11a1.51,1.51,0,0,0-1.3,0,4.4,4.4,0,0,0-.83.42,4.94,4.94,0,0,0-.81.63l.31.68a7.62,7.62,0,0,1,.61-.5,2.68,2.68,0,0,1,.67-.36.62.62,0,0,1,.63,0,.87.87,0,0,1,.2.68V618l-.78.31a4,4,0,0,0-1.59,1,2.08,2.08,0,0,0-.52,1.41,1.23,1.23,0,0,0,.37,1,1.07,1.07,0,0,0,1,0,2.62,2.62,0,0,0,.85-.48,3.32,3.32,0,0,0,.66-.89h0l.19.66.69-.25v-3.52Q410.7,616.39,410.26,616.11Zm-.52,3a1.81,1.81,0,0,1-.32,1.06,1.72,1.72,0,0,1-.84.64.59.59,0,0,1-.54,0,.54.54,0,0,1-.18-.48,1.2,1.2,0,0,1,.31-.83,2.66,2.66,0,0,1,1-.62l.58-.24Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M413.56,614.75a3.29,3.29,0,0,0-.59,1l0,0-.13-.88-.75.27v5.23l1-.35v-2.73a2.3,2.3,0,0,1,.36-1.26,1.84,1.84,0,0,1,.94-.78,1.68,1.68,0,0,1,.43-.1l.09-1.07a2.21,2.21,0,0,0-.48.13A2,2,0,0,0,413.56,614.75Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M417.46,613.06a2.87,2.87,0,0,0-1.52,1.29,4.27,4.27,0,0,0-.55,2.21,2.16,2.16,0,0,0,.6,1.74,1.61,1.61,0,0,0,1.65.11,5,5,0,0,0,.82-.38,4.25,4.25,0,0,0,.71-.53v-.9a5.7,5.7,0,0,1-.74.56,4.05,4.05,0,0,1-.75.36.91.91,0,0,1-.95-.06,1.37,1.37,0,0,1-.36-1l3-1.1v-.6a1.93,1.93,0,0,0-.52-1.54A1.36,1.36,0,0,0,417.46,613.06Zm-1.07,2.54a2.38,2.38,0,0,1,.33-1.1,1.44,1.44,0,0,1,.74-.6.67.67,0,0,1,.72.07,1.19,1.19,0,0,1,.27.88Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "400.92 614.4 396.02 619.55 400.94 620.76 401.43 619.51 398.16 618.71 401.46 615.24 400.92 614.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M390.41,621.24a1.78,1.78,0,0,0-1,1.59c0,.67.47,1,1,.83a1.78,1.78,0,0,0,1-1.59C391.46,621.4,391,621,390.41,621.24Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M386.31,625.56a1.78,1.78,0,0,0-1,1.59c0,.67.47,1,1,.83a1.78,1.78,0,0,0,1-1.59C387.36,625.72,386.89,625.35,386.31,625.56Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M390.41,626.56a1.78,1.78,0,0,0-1,1.59c0,.67.47,1,1,.83a1.78,1.78,0,0,0,1-1.59C391.46,626.72,391,626.35,390.41,626.56Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M450.43,568.49a3,3,0,0,0-1.79,2.71c0,1.14.8,1.77,1.79,1.41a3,3,0,0,0,1.79-2.71C452.21,568.76,451.41,568.13,450.43,568.49Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M458.54,565.54a3,3,0,0,0-1.79,2.71c0,1.14.8,1.77,1.79,1.41a3,3,0,0,0,1.79-2.71C460.32,565.81,459.52,565.18,458.54,565.54Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M466.89,562.5a3,3,0,0,0-1.79,2.71c0,1.14.8,1.77,1.79,1.41a3,3,0,0,0,1.79-2.71C468.68,562.77,467.88,562.14,466.89,562.5Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M495,625.71l-70.62,25.68a1.92,1.92,0,0,0-1.13,1.72c0,.72.51,1.12,1.13.89L495,628.32a1.92,1.92,0,0,0,1.13-1.72C496.08,625.88,495.58,625.48,495,625.71Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M430.6,148.08l-5.39,2v14.38l2.88-1v-4l2.51-.91a7.68,7.68,0,0,0,5.41-7.16C436,148.11,433.93,146.87,430.6,148.08Zm-.16,7.76-2.35.85v-5l2.35-.85c1.76-.64,2.65,0,2.65,1.54A3.58,3.58,0,0,1,430.44,155.84Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M440.34,149.33v-1.46l-2.65,1v11l2.78-1v-5.22a3.91,3.91,0,0,1,2.54-4c.21-.08.39-.12.62-.19v-3A5.85,5.85,0,0,0,440.34,149.33Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M449.69,144.3a8.28,8.28,0,0,0-5.27,7.6c0,3.33,2.22,4.88,5.27,3.77a8.26,8.26,0,0,0,5.25-7.6C454.94,144.75,452.73,143.19,449.69,144.3Zm0,8.75c-1.39.5-2.46-.26-2.46-2.17a4.1,4.1,0,0,1,2.46-4c1.39-.5,2.44.26,2.44,2.17A4.08,4.08,0,0,1,449.69,153Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M461.11,138.49a1.49,1.49,0,0,1,1.12,0l.73-2.59a3.17,3.17,0,0,0-2.12.17,5.57,5.57,0,0,0-3.7,5.45V142l-1.48.54V145l1.48-.54v8.34l2.78-1v-8.34l2.38-.87v-2.46l-2.46.89v-.47A2,2,0,0,1,461.11,138.49Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M466.5,133.24a2.66,2.66,0,0,0-1.73,2.41,1.16,1.16,0,0,0,1.73,1.16,2.68,2.68,0,0,0,1.73-2.48C468.23,133.35,467.53,132.86,466.5,133.24Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "475.89 142.28 478.66 141.27 478.66 130.22 475.89 131.23 475.89 142.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "481.12 140.37 483.89 139.36 483.89 124.13 481.12 125.14 481.12 140.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M480,133.29a8.22,8.22,0,0,0-5.11,7.55c0,3.29,2.15,4.91,5.46,3.7a7.44,7.44,0,0,0,3.95-3.22L482.78,140a4.79,4.79,0,0,1-2.4,1.94c-1.46.53-2.47.06-2.74-1.22l7.24-2.63c0-.27.05-.64.05-.88C484.94,133.66,482.77,132.27,480,133.29Zm-2.35,5.58a3.8,3.8,0,0,1,2.37-3.16,1.62,1.62,0,0,1,2.35,1.45Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M531.23,381.12,352,443.88c-9.26,3.37-16.78,13.61-16.78,22.86v49.07c0,9.26,7.51,14,16.78,10.66l179.24-62.76c9.26-3.37,16.78-13.61,16.78-22.86V391.78C548,382.52,540.49,377.75,531.23,381.12Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M530.65,382.71,352.9,444.95c-9.11,3.31-16.5,13.38-16.5,22.48v47.22c0,9.1,7.39,13.8,16.5,10.48L530.65,462.9c9.11-3.31,16.5-13.38,16.5-22.48V393.19C547.15,384.09,539.76,379.4,530.65,382.71Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M530.08,384.31,353.82,446c-9,3.26-16.22,13.15-16.22,22.1v45.37c0,8.95,7.26,13.56,16.22,10.31l176.26-61.71c9-3.26,16.22-13.15,16.22-22.1V394.61C546.29,385.66,539,381,530.08,384.31Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M529.5,385.9,354.73,447.08c-8.8,3.2-15.94,12.93-15.94,21.72v43.52c0,8.79,7.14,13.33,15.94,10.13L529.5,461.26c8.8-3.2,15.94-12.93,15.94-21.72V396C545.44,387.23,538.3,382.7,529.5,385.9Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M528.93,387.5,355.65,448.15C347,451.29,340,460.85,340,469.49v41.66c0,8.64,7,13.1,15.66,10l173.28-60.65c8.65-3.14,15.66-12.7,15.66-21.34V397.45C544.58,388.81,537.57,384.35,528.93,387.5Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M528.35,389.09,356.56,449.22c-8.49,3.09-15.38,12.47-15.38,21V510c0,8.49,6.88,12.86,15.38,9.77l171.79-60.13c8.49-3.09,15.38-12.47,15.38-21V398.86C543.73,390.38,536.84,386,528.35,389.09Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M527.77,390.69l-170.3,59.6c-8.34,3-15.1,12.25-15.1,20.58v38c0,8.33,6.76,12.63,15.1,9.6l170.3-59.6c8.34-3,15.1-12.25,15.1-20.58v-38C542.87,391.95,536.11,387.65,527.77,390.69Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M527.2,392.28,358.39,451.35c-8.18,3-14.82,12-14.82,20.2v36.11c0,8.18,6.63,12.39,14.82,9.42L527.2,458c8.18-3,14.82-12,14.82-20.2V401.7C542,393.52,535.38,389.3,527.2,392.28Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M526.62,393.88,359.3,452.42c-8,2.92-14.54,11.79-14.54,19.81v34.25c0,8,6.51,12.16,14.54,9.24l167.32-58.54c8-2.92,14.54-11.79,14.54-19.81V403.12C541.16,395.09,534.65,391,526.62,393.88Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M526,395.47l-165.83,58c-7.87,2.86-14.26,11.56-14.26,19.43v32.4c0,7.87,6.38,11.93,14.26,9.06l165.83-58c7.88-2.86,14.26-11.56,14.26-19.43v-32.4C540.3,396.66,533.92,392.61,526,395.47Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M525.47,397.07,361.13,454.55c-7.72,2.81-14,11.34-14,19.05v30.55c0,7.71,6.26,11.69,14,8.88l164.34-57.49c7.72-2.81,14-11.34,14-19.05V405.95C539.45,398.24,533.19,394.26,525.47,397.07Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M524.89,398.66,362,455.62c-7.57,2.75-13.7,11.11-13.7,18.67V503c0,7.56,6.13,11.46,13.7,8.71l162.85-57c7.57-2.75,13.7-11.11,13.7-18.67V407.37C538.59,399.81,532.46,395.91,524.89,398.66Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M524.32,400.26,363,456.69c-7.41,2.7-13.42,10.88-13.42,18.29v26.84c0,7.41,6,11.22,13.42,8.53l161.36-56.43c7.41-2.7,13.42-10.88,13.42-18.29V408.78C537.74,401.38,531.73,397.56,524.32,400.26Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M523.74,401.85,363.88,457.76c-7.26,2.64-13.14,10.66-13.14,17.91v25c0,7.25,5.88,11,13.14,8.35L523.74,453.1c7.26-2.64,13.14-10.66,13.14-17.91v-25C536.88,403,531,399.21,523.74,401.85Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M523.17,403.45,364.79,458.82c-7.1,2.58-12.86,10.43-12.86,17.53v23.14c0,7.1,5.76,10.76,12.86,8.17l158.38-55.38c7.1-2.58,12.86-10.43,12.86-17.53V411.62C536,404.52,530.27,400.86,523.17,403.45Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M522.59,405,365.7,459.89c-6.95,2.53-12.58,10.2-12.58,17.15v21.28c0,6.94,5.63,10.52,12.58,8l156.89-54.85c6.95-2.53,12.58-10.2,12.58-17.15V413C535.17,406.09,529.54,402.51,522.59,405Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M522,406.64,366.62,461c-6.79,2.47-12.3,10-12.3,16.77v19.43c0,6.79,5.51,10.29,12.3,7.82L522,450.65c6.79-2.47,12.3-10,12.3-16.77V414.45C534.32,407.67,528.81,404.16,522,406.64Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M241.72,417.81l-42.13,15.32c-10.13,3.69-18.35,14.88-18.35,25v39.65c0,10.13,8.22,15.35,18.35,11.66l42.13-15.32c10.13-3.69,18.35-14.88,18.35-25V429.47C260.07,419.34,251.85,414.12,241.72,417.81Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M244.52,465.11c-5.14,1.87-9.3,8.19-9.3,14.11h0c0,5.93,4.16,9.21,9.3,7.35s9.3-8.19,9.3-14.11h0C253.82,466.54,249.66,463.25,244.52,465.11Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.25,472.1c-.27-.22-.7-.06-1,.34a.88.88,0,0,0,0,1.12l3.08,2.5-3.1,5.19a.83.83,0,0,0,.06,1.1.5.5,0,0,0,.45,0,1,1,0,0,0,.52-.46l3.52-5.9a.85.85,0,0,0,0-1.07Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M195.41,456a3.58,3.58,0,0,0,1.12-2.55c0-1.52-1.08-2.14-3.19-1.37l-4.12,1.5v9.73l4.36-1.59c2.22-.81,3.37-2.2,3.37-3.88C196.95,456.59,196.35,456,195.41,456Zm-4.25-1.43,1.94-.71c1-.35,1.47-.16,1.47.61s-.52,1.34-1.47,1.69l-1.94.71Zm2.28,5.51-2.28.83v-2.41l2.28-.83c1-.37,1.56-.18,1.56.64S194.44,459.69,193.43,460.06Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M200.95,451.43a6.86,6.86,0,0,0-2.8,1.92l.67,1.27a4.43,4.43,0,0,1,1.87-1.38c1-.37,1.49,0,1.49.93l-1.49.54c-2,.72-2.78,1.93-2.78,3.25s.9,1.94,2.42,1.39a3.27,3.27,0,0,0,2-1.76v.93l1.76-.64v-4.27C204.07,451.35,202.92,450.71,200.95,451.43Zm1.24,4.78a2.25,2.25,0,0,1-1.39,1.52c-.66.24-1.06,0-1.06-.52s.28-1,1.16-1.3l1.29-.47Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M207.06,451.54c0-.39.36-.83,1.2-1.13a3,3,0,0,1,1.87-.12l.63-1.77a4.36,4.36,0,0,0-2.49.25c-1.89.69-3,2.09-3,3.51,0,3,3.92.31,3.92,1.54,0,.42-.33.8-1.19,1.11a3.47,3.47,0,0,1-2.25.1l-.63,1.78a4.44,4.44,0,0,0,2.81-.21c1.94-.71,3.06-2.1,3.06-3.49C211,450.16,207.06,452.82,207.06,451.54Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "222.86 447.34 224.74 446.66 224.74 439.18 222.86 439.86 222.86 447.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M213,443.69a1.8,1.8,0,0,0-1.17,1.63.79.79,0,0,0,1.17.78,1.81,1.81,0,0,0,1.17-1.68C214.19,443.76,213.72,443.43,213,443.69Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M218.7,446.75a1.11,1.11,0,0,1,1.46.5l1.46-1.43c-.47-1.05-1.54-1.34-2.9-.85a5.62,5.62,0,0,0-3.62,5.17c0,2.25,1.51,3.3,3.62,2.54a4.81,4.81,0,0,0,2.9-2.95l-1.46-.39a2.58,2.58,0,0,1-1.46,1.56c-1,.35-1.7-.15-1.7-1.45A2.8,2.8,0,0,1,218.7,446.75Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "199.52 471.38 263.73 448.13 263.73 440.25 199.52 463.5 199.52 471.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M335.61,383.66,293.48,399c-10.13,3.69-18.35,14.88-18.35,25v39.65c0,10.13,8.22,15.35,18.35,11.66L335.61,460C345.75,456.3,354,445.1,354,435V395.32C354,385.19,345.75,380,335.61,383.66Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M338.42,431c-5.14,1.87-9.3,8.19-9.3,14.11h0c0,5.93,4.16,9.21,9.3,7.35s9.3-8.19,9.3-14.11h0C347.72,432.39,343.56,429.1,338.42,431Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M337.15,438c-.27-.21-.7-.06-1,.34a.88.88,0,0,0,0,1.12l3.08,2.5-3.1,5.19a.83.83,0,0,0,.06,1.1.5.5,0,0,0,.45,0,1,1,0,0,0,.52-.46l3.52-5.9a.86.86,0,0,0,0-1.07Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M286.76,418.08l-3.65,1.33v9.73l2-.71v-2.68l1.7-.62a5.2,5.2,0,0,0,3.66-4.85C290.42,418.09,289,417.26,286.76,418.08Zm-.11,5.25-1.59.58v-3.38l1.59-.58c1.19-.43,1.79,0,1.79,1A2.42,2.42,0,0,1,286.65,423.33Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M293.36,418.92v-1l-1.8.65v7.48l1.88-.68v-3.53a2.65,2.65,0,0,1,1.72-2.71l.42-.13v-2A4,4,0,0,0,293.36,418.92Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M299.71,415.51a5.61,5.61,0,0,0-3.57,5.15c0,2.25,1.51,3.3,3.57,2.55a5.59,5.59,0,0,0,3.55-5.14C303.27,415.82,301.77,414.76,299.71,415.51Zm0,5.92c-.94.34-1.66-.17-1.66-1.47a2.78,2.78,0,0,1,1.66-2.68c.94-.34,1.65.18,1.65,1.47A2.76,2.76,0,0,1,299.71,421.43Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M307.41,411.58a1,1,0,0,1,.76,0l.49-1.75a2.15,2.15,0,0,0-1.43.12,3.77,3.77,0,0,0-2.51,3.69V414l-1,.36V416l1-.36v5.65l1.88-.68v-5.65l1.61-.59v-1.67l-1.66.6V413A1.32,1.32,0,0,1,307.41,411.58Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "293.88 436.75 346.99 417.44 346.99 409.56 293.88 428.87 293.88 436.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M427.19,350.35l-42.13,15.32c-10.13,3.69-18.35,14.88-18.35,25v39.65c0,10.13,8.22,15.35,18.35,11.66l42.13-15.32c10.13-3.69,18.35-14.88,18.35-25V362C445.54,351.89,437.33,346.67,427.19,350.35Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M430,397.66c-5.14,1.87-9.3,8.19-9.3,14.11h0c0,5.93,4.16,9.21,9.3,7.35s9.3-8.19,9.3-14.11h0C439.3,399.08,435.13,395.79,430,397.66Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M428.73,404.65c-.27-.22-.7-.06-1,.34a.88.88,0,0,0,0,1.12l3.08,2.5-3.1,5.19a.83.83,0,0,0,.06,1.1.5.5,0,0,0,.45,0,1,1,0,0,0,.52-.46l3.52-5.9a.86.86,0,0,0,0-1.07Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M380.88,388.52A3.58,3.58,0,0,0,382,386c0-1.52-1.08-2.14-3.19-1.37l-4.12,1.5v9.73l4.36-1.59c2.22-.81,3.37-2.2,3.37-3.88C382.42,389.14,381.82,388.53,380.88,388.52Zm-4.25-1.43,1.94-.71c1-.35,1.47-.16,1.47.61s-.52,1.34-1.47,1.69l-1.94.71Zm2.28,5.51-2.28.83V391l2.28-.83c1-.37,1.55-.18,1.55.64S379.92,392.23,378.91,392.6Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M388.38,387.07a2.49,2.49,0,0,1-1.49,2.56c-.83.3-1.31-.08-1.31-1.33V384.4l-1.88.68v4.23c0,2.31,1.14,2.95,2.77,2.36a4,4,0,0,0,2-1.73v.89l1.78-.65v-7.48l-1.88.68Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M393.32,383.8c0-.39.36-.83,1.2-1.13a3,3,0,0,1,1.87-.12l.63-1.77a4.36,4.36,0,0,0-2.49.25c-1.89.69-3,2.09-3,3.51,0,3,3.92.31,3.92,1.54,0,.42-.33.8-1.19,1.11a3.47,3.47,0,0,1-2.25.1l-.63,1.78a4.44,4.44,0,0,0,2.81-.21c1.94-.71,3.06-2.1,3.06-3.49C397.24,382.42,393.32,385.08,393.32,383.8Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "409.12 379.6 411 378.91 411 371.44 409.12 372.12 409.12 379.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M399.29,375.94a1.8,1.8,0,0,0-1.17,1.63.78.78,0,0,0,1.17.78,1.81,1.81,0,0,0,1.17-1.68C400.46,376,400,375.69,399.29,375.94Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M405.79,376.93a4.23,4.23,0,0,0-2.15,1.77v-.88l-1.8.65V386l1.88-.68v-3.7a2.53,2.53,0,0,1,1.55-2.58c.83-.3,1.31.08,1.31,1.29v3.95l1.88-.68v-4.28C408.47,377,407.32,376.38,405.79,376.93Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M413,374.29a5.56,5.56,0,0,0-3.46,5.11c0,2.22,1.46,3.32,3.7,2.51a5,5,0,0,0,2.68-2.18l-1-.89a3.24,3.24,0,0,1-1.63,1.31c-1,.36-1.68,0-1.86-.83l4.9-1.78c0-.19,0-.43,0-.6C416.42,374.54,414.95,373.6,413,374.29Zm-1.59,3.78a2.58,2.58,0,0,1,1.6-2.14,1.09,1.09,0,0,1,1.59,1Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M419,374.47c0-.39.36-.83,1.2-1.13a3,3,0,0,1,1.87-.12l.63-1.77a4.35,4.35,0,0,0-2.49.25c-1.89.69-3,2.09-3,3.51,0,3,3.92.31,3.92,1.54,0,.42-.33.8-1.19,1.11a3.47,3.47,0,0,1-2.25.1l-.63,1.78a4.44,4.44,0,0,0,2.81-.21c1.94-.71,3.06-2.1,3.06-3.49C422.91,373.08,419,375.74,419,374.47Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M425.43,372.13c0-.39.36-.83,1.2-1.13a3,3,0,0,1,1.87-.12l.63-1.77a4.36,4.36,0,0,0-2.49.25c-1.89.69-3,2.09-3,3.51,0,3,3.92.31,3.92,1.54,0,.42-.33.8-1.19,1.11a3.47,3.47,0,0,1-2.25.1l-.63,1.78a4.44,4.44,0,0,0,2.81-.21c1.94-.71,3.06-2.1,3.06-3.49C429.34,370.74,425.43,373.4,425.43,372.13Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "385.8 404.51 447.55 382.27 447.55 374.39 385.8 396.63 385.8 404.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M543.53,399.89,369.89,463c-5.95,2.16-10.81,8.79-10.81,14.74v28.46c0,5.94,4.87,9,10.81,6.87L543.53,450c5.95-2.16,10.81-8.79,10.81-14.74V406.76C554.35,400.82,549.48,397.73,543.53,399.89Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M382.17,470.16c-6.44,2.34-11.66,10.26-11.66,17.69s5.22,11.55,11.66,9.21,11.66-10.26,11.66-17.69S388.61,467.82,382.17,470.16Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "416.23 463.94 528.89 423.32 528.89 415.44 416.23 456.06 416.23 463.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "416.23 479.47 468.96 460.95 468.96 453.08 416.23 471.59 416.23 479.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M540.79,422.51c-.27-.22-.7-.06-1,.34a.88.88,0,0,0,0,1.12l3.08,2.5-3.1,5.19a.83.83,0,0,0,.06,1.1.5.5,0,0,0,.45,0,1,1,0,0,0,.52-.46l3.52-5.9a.85.85,0,0,0,0-1.07Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M543.53,467.21,369.89,530.36c-5.95,2.16-10.81,8.79-10.81,14.74v28.46c0,5.94,4.87,9,10.81,6.87l173.65-63.15c5.95-2.16,10.81-8.79,10.81-14.74V474.08C554.35,468.14,549.48,465,543.53,467.21Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M382.17,537.47c-6.44,2.34-11.66,10.26-11.66,17.69s5.22,11.55,11.66,9.21,11.66-10.26,11.66-17.69S388.61,535.13,382.17,537.47Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "416.23 531.25 528.89 490.64 528.89 482.76 416.23 523.37 416.23 531.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "416.23 546.78 468.96 528.27 468.96 520.39 416.23 538.9 416.23 546.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M540.79,489.83c-.27-.22-.7-.06-1,.34a.88.88,0,0,0,0,1.12l3.08,2.5-3.1,5.2a.83.83,0,0,0,.06,1.1.5.5,0,0,0,.45,0,1,1,0,0,0,.52-.46l3.52-5.9a.86.86,0,0,0,0-1.07Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M540.13,102.75a1.44,1.44,0,0,0-.85,1.29v2.43c0,.54.38.84.85.67a1.44,1.44,0,0,0,.85-1.29v-2.43C541,102.88,540.6,102.58,540.13,102.75Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M540.13,118.29a1.44,1.44,0,0,0-.85,1.29V122c0,.54.38.84.85.67a1.44,1.44,0,0,0,.85-1.29V119C541,118.42,540.6,118.12,540.13,118.29Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M546.45,105.07l-1.82,1.88a1.29,1.29,0,0,0-.31,1.45.58.58,0,0,0,.74.22,1.14,1.14,0,0,0,.42-.29l1.82-1.88a1.29,1.29,0,0,0,.31-1.45C547.38,104.63,546.86,104.65,546.45,105.07Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M534.79,117.08,533,119a1.29,1.29,0,0,0-.31,1.45.58.58,0,0,0,.74.22,1.14,1.14,0,0,0,.42-.29l1.82-1.88a1.29,1.29,0,0,0,.31-1.45C535.71,116.64,535.19,116.67,534.79,117.08Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M547.3,113.75l-1.82-.55c-.4-.12-.92.23-1.16.78s-.1,1.1.31,1.22l1.82.55a.67.67,0,0,0,.42,0,1.36,1.36,0,0,0,.74-.76C547.85,114.42,547.71,113.87,547.3,113.75Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M535.64,110.22l-1.82-.55c-.4-.12-.93.23-1.16.78s-.1,1.1.31,1.22l1.82.55a.67.67,0,0,0,.42,0,1.36,1.36,0,0,0,.74-.76C536.18,110.89,536,110.34,535.64,110.22Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M540.13,105.42c-3.48,1.27-6.32,5.57-6.32,9.59s2.83,6.26,6.32,5,6.32-5.57,6.32-9.59S543.62,104.15,540.13,105.42Zm0,12.62c-2.55.93-4.62-.71-4.62-3.65a7.87,7.87,0,0,1,4.62-7c2.55-.93,4.62.71,4.62,3.65A7.87,7.87,0,0,1,540.13,118Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M307.27,825.1c-27.16,20.5-48.64,14.69-60.69,9.75-20.23-8.3-33.38-9.82-23.3,10.11C231.41,861,255,866,270.79,875.25c18.34,10.67,22.41-12.25,43.57-22.73C337.7,840.95,307.27,825.1,307.27,825.1Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M312.06,821.51c-26.95,20.34-48.27,14.58-60.22,9.67-20.07-8.24-33.13-9.74-23.12,10,8.07,15.94,31.45,20.94,47.14,30.07,18.2,10.58,22.24-12.16,43.23-22.56C342.24,837.24,312.06,821.51,312.06,821.51Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M475.8,870.88c3.14,33.86-14.53,29.7-24.8,32.06-21.31,4.89-24.12,21.12-1.86,23,17.95,1.55,34,10.89,50.11,2.3,18.73-10,1.38-25.49,3.6-49C505.3,853.39,475.8,870.88,475.8,870.88Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M502.29,873c2.45-25.92-27.05-8.42-27.05-8.42,3.14,33.86-14.24,24.43-24.8,32.06-17.72,12.81-25.93,23.19-3.67,25.12,17.95,1.55,35.77,8.82,51.92.23C517.43,912,500.07,896.51,502.29,873Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M618.74,522.45c-5,1.44-17.25,3.34-19.06,8.39l13.64,5.78S661.09,516.77,659,512,628.72,519.58,618.74,522.45Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M660,535.9c6.51,9.07-47.81,12-46.23,1s-6.82-30.11-8.4-38c-1.06-5.28,36.38-37.47,42.61,4.42C649.39,512.69,653.35,526.6,660,535.9Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M604.17,520.31c13.49-1.11,20.19,25,20.19,25,77.22,6.23,33.46-32.89,31.7-40.34C656.06,504.94,595.53,521,604.17,520.31Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M581.59,420.11a33.57,33.57,0,0,1,31,1.57c4.67,2.67,10.76,1.89,15.23,0,10.7-4.57,38.81,8,36,30.15-6.14,9.48-5.71,8.81-17.91,15-7.27,3.67-43.64-2.32-47,3l-6.48-6.52C575.88,467.87,550.86,434.16,581.59,420.11Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M615.54,456.71c.76-7-12.1-10.49-17.78-8.7-30.63,9.68-22.19-1.26-33.33,14.89-8,11.67,10.48,6.58,10.48,6.58l21.76,7.19,39.08,4,2.62-.59C631.91,470,614.77,463.73,615.54,456.71Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610.86,449.84c19.52,9.44,46.7,11.78,53,2-3.9,24.56-9.07,39.67-14.21,58.08l-24.53,3.81-26.16-43.92C602.28,463.91,603.37,446.21,610.86,449.84Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M613,453.93a6.75,6.75,0,0,0-3.78-4.87l-.14-.06-13.68,5.87,22.71,64.87s33.93-1.79,23.52-11.9C632.11,498.58,615.75,467.74,613,453.93Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M616.39,480.47c2,4.75,3.81,12.74-.16,17.89,6.18,8.76,16.64,13.94,15.87,14.25-11.16,4.46-23.41,8.59-27.55,8.69-8.84.2-13.43-26.88-14-31.91-.93-8,2.66-9.08,3.61-17C594.68,468,591,459.6,591,459.6c6.49-3.05,7.6-2.25,14.62,15.93C607.35,479.92,610.4,465.95,616.39,480.47Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M613.46,429.25l-23.08,5c3,3.46,9.66,15.48,10.92,26.32,1.29,11.11,2.18,13.29-1.06,16.53-14.41,14.4,5.6,50.72,19.69,57.76C687,568.39,614.92,429.26,613.46,429.25Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M608.69,485.15c.14,2.08.92,6.58,3.21,7.63,5.19,2.38,2.68-10.6,1-13.4S608.15,477.16,608.69,485.15Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M626.8,683c-22.73,1.62-80.27,8.21-108.75,8.21s-37,3-37.79,17.13C479.53,720.95,476,864,476,890.08c0,6.86,27,17,31.36,2.33s12.63-42.14,14.67-82.75-9.49-59.29,6.77-55.23,59.68,3.79,89.94-.27,33.62,12.72,57.36-66.06C676.12,688.1,649.53,681.34,626.8,683Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M586.16,696.77c-27.25,1.62-78.43,3.77-112.57,3.77s-28.71-1.08-43.53,11.1C405.41,731.89,316.93,809,296.14,827c-11.68,10.07,7.24,34.82,21.7,29,21.68-8.8,53.4-31.91,105.43-71.37,31.41-23.82,40-22.83,59.54-18.77S573.52,796.58,609,788.12c68.16-16.24,86.25-47.85,89.56-88C698.58,700.07,613.41,695.14,586.16,696.77Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M461.44,626.11c-3.21-4.37.72-11.91-2.44-17.07s-4.52,1.09-5,6.51-3.39,6-6.73,2.64-6.84-6.39-11.52-11c-5.12-5-9.48-2-3.66,3.85,4.72,4.71,5.83,6.63,3.39,9.07s-3.06,11.42-1.63,14.48,12.85,5.28,15.56,6.9,20.93,23.66,20.93,23.66L479.24,643S464.65,630.48,461.44,626.11Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M687.91,521.3c-9.78-7.69-21.49.3-28.94-9.31-7.31,8.63-57.21,21.39-59.29,18.86,0,0-5.87,19.12-15.35,26.52-6.53,5.1-13.76,9.21-17.36,13.75-.14-.13-16.62,36.07-32.45,55.62-18.29,22.57-24.25,32.44-29.77,29.05s-23.1-11.37-25.5-12.83S463.55,663,472,670.3s34.62,28.1,46.2,26.81c8.77-1,44.21-36.41,63.94-60.41,8.2,29.38-7.67,67.76-6.08,82,3.69,32.9,109,25.31,122.51-18.65C710.62,653.81,714.14,541.91,687.91,521.3Z",
    transform: "translate(10.77 -7.63)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M691.66,498.35,676.12,489l-27.46,4-4.09,27.06c-1,12.94-39.14,27.45-54.19,48.17S527.07,685.66,504,692.88s-6.45,19.59,6.07,19.59S549,701,549,701l38.29,62.4,107.29-30L723.45,701,713.33,554.72Z",
    transform: "translate(10.77 -7.63)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M584.45,652.45c.57,15.41-2.92,31.61-5.59,44.74-28.38,1.55-74,3.36-105.26,3.36-34.14,0-28.71-1.08-43.53,11.1C405.41,731.89,316.93,809,296.14,827c-4.27,3.68-4.44,9.33-2.24,14.72,18-18.65,81.27-79.45,105.44-98.27,22.27-17.34,32.78-37.8,71.53-32.45s85.36,0,109.43,13.37c8.18,4.55,16.79-10.91,14.19-41.63C592.85,663.43,591.56,655.74,584.45,652.45Z",
    transform: "translate(10.77 -7.63)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.af2432a43f62cd42d41cdf5e24b6a722.svg";
export { ForwardRef as ReactComponent };